import {FrameSelectorPage} from 'components/FrameSelector';
import GoneTableFrame from 'containers/GoneTableFrame/Container';
import NewWordsFrame from 'containers/NewWordsFrame/Container';
import OldNewWordsFrame from 'containers/OldNewWordsFrame/Container';
import OmonymsFrame from 'containers/OmonymsFrame/Container';
import ResearchApp from 'containers/ResearchApp/Container';
import React from 'react';
import tests from 'tests/test-frames';
import {isProdBuild} from 'utils/env';

export default {
  ResearchApp() {
    return <ResearchApp />;
  },
  OldNewWordsFrame() {
    return <OldNewWordsFrame />;
  },
  GoneTableFrame() {
    return <GoneTableFrame />;
  },
  NewWordsFrame() {
    return <NewWordsFrame />;
  },
  OmonymsFrame() {
    return <OmonymsFrame />;
  },
  ...(isProdBuild ? {} : {tests}),
} as FrameSelectorPage;
